import { render, staticRenderFns } from "./CampaignMessageTable.vue?vue&type=template&id=350c3622&scoped=true&"
import script from "./CampaignMessageTable.vue?vue&type=script&lang=js&"
export * from "./CampaignMessageTable.vue?vue&type=script&lang=js&"
import style0 from "./CampaignMessageTable.vue?vue&type=style&index=0&id=350c3622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350c3622",
  null
  
)

export default component.exports